// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4606":"15aa28abf027ce47","8661":"f08dc14d053ed25a"}[chunkId] + ".js";
};